import { mapGetters, mapActions } from 'vuex';

export default {
  mounted() {
    if (!this.collectList.length) {
      this.fetchCollectList();
    }
  },
  computed: {
    ...mapGetters(['collectList']),
  },
  methods: {
    ...mapActions(['fetchCollectList', 'addCollect', 'delCollect']),
  },
};
